<template>
    <div class="Home">
        <div class="container">
            <img :src="contentImage" class="radius-pic mt-3">

            <div class="phone-btn mt-2">
                <a @click="$public.callTel(phone)" v-if="phone !== ''">
                    <img src="@/assets/images/phone.svg">
                    <span>{{phone}}</span>
                </a>
            </div>
            <div class="location-btn">
                <a @click="$public.openMapByAddress(cityName+townName+address)" v-if="cityName !== ''">
                    <img src="@/assets/images/location_blue.svg">
                    <span>{{cityName}}{{townName}}{{address}}</span>
                </a>
            </div>
            <div class="shadow-line"></div>
            <h4 class="line mb-4">{{showStartAt}}~{{showEndAt}}</h4>
            <h4 class="line mb-3">標題/介紹</h4>
            <div class="ml-3 mr-3" v-html="content">
            </div>
        </div>

        <el-dialog
                title="設置鬧鐘提醒"
                :visible.sync="remindModel"
                width="90%"
                center>
            <p class="text-center">我要設置鬧鐘提醒，絕不錯過「活動」</p>
            <span slot="footer" class="dialog-footer">
                        <el-button @click="remindModel = false">取消</el-button>
                <!--TODO 然後連到手機鬧鐘(這邊就看使用者自己要怎麼設置提醒)APP的行事曆也會連動記錄這天有活動-->
                        <el-button @click="remindModel = false">前往設置鬧鐘</el-button>
                    </span>
        </el-dialog>
        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
    </div>
</template>

<script>

    export default {
        name: 'ActivityHome',
        data() {
            return {
                id: this.$route.query.id,
                remindModel: false,

                name: '',
                content: '',
                address: '',
                phone: '',
                contentImage: '',
                showStartAt: '',
                showEndAt: '',
                townName: '',
                cityName: '',
                lat: '',
                lng: '',
                isLoading: true
            }
        },
        created() {
            this.setupData();
        },
        methods: {
            setupData: function () {
                this.$http.fetch`GetOinActivityInfo${{
                    'id': parseInt(this.id),
                }}
                ${json => {
                    this.name = json.name;
                    this.content = json.content;
                    this.address = json.address;
                    this.phone = json.phone;
                    this.contentImage = json.contentImage;
                    this.showStartAt = json.showStartAt;
                    this.showEndAt = json.showEndAt;
                    this.townName = json.townName;
                    this.cityName = json.cityName;
                    this.lat = json.lat;
                    this.lng = json.lng;
                    this.isLoading = false
                }}`;
            },

            /** 點擊地點按鈕 */
            onClickLocationBtn: function () {
                //開啓地圖
                if (this.$public.notNull(this.storeInfo.googleMapUrl) && this.googleMapLat > 0 && this.googleMapLng > 0) {
                    //爲避免店家輸入的url打開後效果不統一，一律先分析再從公用函式開啓頁面
                    this.$public.openMap(this.googleMapLat, this.googleMapLng, this.googleMapStoreInfoData);
                } else {
                    this.$public.openMap(this.storeInfo.lat, this.storeInfo.lng);
                }
            },
        }
    }
</script>
<style lang="less" scoped src="../../less/activity.less"/>